import { Component, Input } from '@angular/core';

@Component({
  selector: 'split-line-trash-plus',
  templateUrl: './line-trash-plus.component.html',
  styleUrls: ['./line-trash-plus.component.scss'],
})
export class LineTrashPlusComponent {
  delete = true;
  data = ['Cardiologia', 'Ortopedia', 'Neurologia', 'Neurologia'];

  adicionarEstaEspecialidade() {
    this.delete = true;
    console.log('adicionei uma nova especialidade');
  }

  adicionarEspecialidade() {
    this.delete = false;
    console.log('troca de pagina');
  }
}
